import React from "react";
import { OpenAnswerValue } from "consumerhouse-shared";
import { OpenConditionValue } from "consumerhouse-shared";
import { RawFormInput, RawFormTextArea } from "../FormElements";
import { ConditionEditProps, QuestionContainer, QuestionDefinition, QuestionProps } from "../QuestionAnswer";
import { faKeyboard } from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "../../useLanguage";

export const OpenQuestionDefinition: QuestionDefinition = {
    icon: faKeyboard,
    defaultOptions: {},
    questionComponent: OpenQuestion,
    conditionEditComponent: OpenConditionEdit,
};

function OpenQuestion(props: QuestionProps<{}, OpenAnswerValue>) {
    const language = useLanguage();
    return (
        <QuestionContainer>
            <RawFormTextArea
                rows={4}
                placeholder={language("text")}
                style={{ width: "100%", maxWidth: "500px" }}
                disabled={props.readOnly}
                defaultValue={props.value?.value ?? ""}
                onBlur={(e) => {
                    let val: OpenAnswerValue = {
                        value: e.target.value,
                    };
                    props.onChange(val);
                }}
                maxLength={750}
            />
        </QuestionContainer>
    );
}

function OpenConditionEdit(props: ConditionEditProps<OpenConditionValue>) {
    const value: OpenConditionValue = props.condition.valueJson ?? { contains: "" };
    return (
        <div>
            Moet &nbsp;
            <RawFormInput value={value.contains} onChange={(ev) => props.onChange({ contains: ev.target.value })} />
            &nbsp; bevatten
        </div>
    );
}
